import { Link } from 'react-router-dom';
import {
  MAX_CELL_IN_ROW,
  multiRowMap
} from '../../pages/tm/investigation/metaUtils';
import React from 'react';
import classnames from 'classnames';
import CircularProgressBar from '../CircularProgressBar';
import { AnomalyAction } from '../../pages/tm/investigation/AnomalyAction';
import { truncate, isEmpty } from 'lodash';
import style from '../../pages/tm/dashboard/TookiTakiTable/CustomerProfileTable.scss';

import { isEmptyNullUndef } from '../../services/util';

/**
 * getAlertIdRow
 * @param tableRow
 * @param row
 * @param includeCell
 * @returns {*}
 */
export function getAlertIdRow(tableRow, row, includeCell) {
  return (
    <td title={tableRow[row.key]} key={row.key}>
      <strong>
        <Link
          to={{
            pathname: `/app/tm/investigation/${tableRow[row.key]}`
          }}>
          {tableRow[row.key]}
        </Link>
      </strong>
      <br />
      {includeCell && tableRow[multiRowMap[row.key][0]]}
    </td>
  );
}

/**
 * getAlertStatusRow
 * @param tableRow
 * @param row
 * @param includeCell
 * @returns {*}
 */
export function getAlertStatusRow(tableRow, row, includeCell) {
  return (
    <td title={tableRow[row.key]} key={row.key}>
      <strong>{tableRow[row.key]}</strong>
      <br />
      {tableRow[row.key] === 'Closed' &&
        includeCell &&
        tableRow[multiRowMap[row.key][0]]}
    </td>
  );
}

/**
 * getAlertLevelRow
 * @param tableRow
 * @param row
 * @returns {*}
 */
export function getAlertLevelRow(tableRow, row) {
  {
    let colorValue = null;
    switch (tableRow['alertSourceId']) {
      case 'CRS':
      case '2':
        colorValue = '#4CAF50';
        break;
      case 'ANOMALY':
      case '1':
        colorValue = '#BC24DA';
        break;
      case 'ALERT':
      case '0':
        colorValue = 'rgb(232, 82, 82)';
        break;
      default:
        colorValue = '#000000';
        break;
    }
    const colVal = (
      <div className="row">
        <div className={classnames(style.textRight, 'col-sm-12')}>
          <CircularProgressBar
            key={row.key}
            percentage={Number(tableRow[row.key]).toFixed(2)}
            strokeFill={colorValue}
          />
        </div>
      </div>
    );
    return <td>{colVal}</td>;
  }
}

/**
 * getFirstRow
 * @param key
 * @param tableRow
 * @returns {*}
 */
export const getFirstRow = (key, tableRow) => {
  const compositeKey = `${tableRow[key]}`;
  if (key === 'alertStatus') {
    return (
      <tr>
        <td>{tableRow[key]}</td>
      </tr>
    );
  }
  if (key === 'alertId') {
    return (
      <tr>
        <td>
          {
            <strong>
              <Link
                to={{
                  pathname: `/app/tm/investigation/${compositeKey}`
                }}>
                {tableRow[key]}
              </Link>
            </strong>
          }
        </td>
      </tr>
    );
  } else {
    return (
      <tr>
        <td>{<strong>{tableRow[key] ? tableRow[key] : '-'}</strong>}</td>
      </tr>
    );
  }
};

/**
 * getFilteredRemainingRows
 * @param key
 * @param subColumns
 * @param userFilters
 * @param tableRow
 * @param dispatchInitialRequest
 * @returns {*}
 */
export const getFilteredRemainingRows = (
  key,
  subColumns,
  userFilters,
  tableRow,
  dispatchInitialRequest
) => {
  return subColumns.map((column) => {
    if (
      column.key === 'analystName' &&
      tableRow['alertStatus'] === 'Open' &&
      userFilters[key][column.key]
    ) {
      return (
        <tr>
          <td />
        </tr>
      );
    } else if (
      column.key === 'analystName' &&
      tableRow['alertStatus'] !== 'Open' &&
      userFilters[key][column.key]
    ) {
      if (tableRow?.analystDetails) {
        const { firstName, lastName } = tableRow['analystDetails'];

        return (
          <tr>
            <td>{`${firstName} ${lastName}`}</td>
          </tr>
        );
      } else {
        return (
          <tr>
            <td>{tableRow['analystName']}</td>
          </tr>
        );
      }
    }

    // is column filtered
    if (column.key === 'action') {
      return <tr>{getAnomalyActionRow(tableRow, dispatchInitialRequest)}</tr>;
    }
    if (column.key === 'alertScore' && userFilters[key][column.key]) {
      let colorValue = null;
      switch (tableRow['alertSourceId']) {
        case '1':
          colorValue = '#BC24DA';
          break;
        case '0':
          colorValue = '#E85252';
          break;
        default:
          colorValue = '#000000';
          break;
      }
      return (
        <tr>
          <td>
            <CircularProgressBar
              key={column.key}
              percentage={Number(tableRow[column.key]).toFixed(2)}
              strokeFill={colorValue}
            />
          </td>
        </tr>
      );
    }

    if (column.key === 'expectedCloseDate' && userFilters[key][column.key]) {
      return (
        <tr>
          <td>
            {tableRow['expectedCloseDate']
              ? tableRow['expectedCloseDate']
              : '-'}
          </td>
        </tr>
      );
    }

    if (!isEmpty(userFilters))
      if (userFilters[key][column.key]) {
        return (
          <tr>
            <td>{tableRow[column.key] ? tableRow[column.key] : '-'}</td>
          </tr>
        );
      } else {
        return (
          <tr>
            <td />
          </tr>
        );
      }
  });
};

/**
 * getDefaultMultiMapRow
 * @param tableRow
 * @param row
 * @param userFilters
 * @param dispatchInitialRequest
 * @returns {*}
 */
export function getDefaultMultiMapRow(
  tableRow,
  row,
  userFilters,
  dispatchInitialRequest
) {
  const { key, visibilityFilterKey, subColumns } = row;
  return (
    <td title={tableRow[row.key]} key={row.key}>
      {getFirstRow(key, tableRow)}
      {getFilteredRemainingRows(
        key,
        subColumns,
        userFilters,
        tableRow,
        dispatchInitialRequest
      )}
      {getFillerTD(MAX_CELL_IN_ROW - subColumns.length)}
    </td>
  );
}

/**
 * getAnomalyActionRow
 * @param tableRow
 * @param dispatchInitialRequest
 * @returns {*}
 */
export function getAnomalyActionRow(tableRow, dispatchInitialRequest) {
  return (
    <td title={'action'} key={'action'}>
      <AnomalyAction
        dispatchInitialRequest={dispatchInitialRequest}
        data={tableRow}
      />
    </td>
  );
}

/**
 * getFillerTD component
 * @param fillerTD
 * @returns {*[]}
 */
export function getFillerTD(fillerTD) {
  return [...Array(fillerTD)].map((e, i) => {
    return (
      <tr>
        <td style={{ height: 15 }} />
      </tr>
    );
  });
}

/**
 * getDefaultTableRow
 * @param tableRow
 * @param row
 * @param fillerTDNumber
 * @returns {*}
 */
export function getDefaultTableRow(tableRow, row, fillerTDNumber) {
  if (row.key === 'rules') {
    return getRulesTableRow(tableRow);
  }
  return (
    <td>
      <table style={{ width: '100%' }}>
        <tr>
          <td title={tableRow[row.key]} key={row.key}>
            {tableRow[row.key] ? tableRow[row.key] : '-'}
          </td>
        </tr>
        {getFillerTD(fillerTDNumber)}
      </table>
    </td>
  );
}

/**
 * getRulesTableRow
 * @param tableRow
 * @returns {*}
 */
export function getRulesTableRow(tableRow) {
  const { rules = [], alertSourceId } = tableRow || {};
  if (Array.isArray(rules) && alertSourceId === '0') {
    if (rules.length === 0) {
      return <td>-</td>;
    }
    return (
      <td>
        <div
          style={{
            display: 'flex',
            flexDirection: 'column',
            flexWrap: 'wrap'
          }}>
          <div
            title={rules.join(', ')}
            style={{
              maxWidth: 150,
              wordBreak: 'break-word'
            }}>
            {truncate(rules.join(', '), { length: 40 })}
          </div>
        </div>
      </td>
    );
  } else {
    return <td>{rules ? rules : '-'}</td>;
  }
}

/**
 * This is the method to determine INDIVIDUAL / CORPORATE customers
 * @param type
 * @returns {string}
 */
export const getCustomerType = (type) => {
  if (type === 'CORPORATE' || type === 'C') {
    return 'Corporate';
  }
  if (type === 'INDIVIDUAL' || type === 'I') {
    return 'Individual';
  }
  return 'NA';
};

/**
 * Determine Risk Rating Background Color
 * @param riskRating
 * @returns {*|{style: string, label: string}|{style: *, label: string}}
 */
export const getRiskRatingColor = (riskRating) => {
  if (riskRating === 'Low Risk' || riskRating === 'Low') {
    return { style: style.status_low, label: 'Low' };
  } else if (riskRating === 'Medium Risk' || riskRating === 'Medium') {
    return { style: style.status_medium, label: 'Medium' };
  } else if (riskRating === 'High Risk' || riskRating === 'High') {
    return { style: style.status_high, label: 'High' };
  }
  return { style: '', label: '-' };
};

export const getGender = (gender) => {
  if (!isEmptyNullUndef(gender)) {
    if (gender.toLowerCase() === 'm' || gender.toLowerCase() === 'male') {
      return 'Male';
    }
    if (gender.toLowerCase() === 'f' || gender.toLowerCase() === 'female') {
      return 'Female';
    }
    return '-';
  }
  return '-';
};

export const getHighRiskPartyInfo = (highRiskPartyInfo) => {
  let expirationDate = '-';
  let predefinedComments = '-';
  try {
    const hRPInfoJson = JSON.parse(highRiskPartyInfo);
    if (!isEmpty(hRPInfoJson)) {
      expirationDate = hRPInfoJson.expiration_date;
      predefinedComments = hRPInfoJson.predefined_comments;
    }
  } catch (err) {}
  return {
    expirationDate,
    predefinedComments
  };
};
